import { type ReactNode } from "react";

export interface ProgressPoint {
  id: number;
  owner: string;
  definition: ReactNode;
  notes: ReactNode;
}

export const progressPointsRows: ProgressPoint[] = [
  {
    id: 1,
    owner: "Lab/Vendor and NIAP",
    definition: (
      <>
        <b>Check-In Package Completed</b> – Achieved when NIAP receives and
        accepts the Check-In Package for a new evaluation start.
      </>
    ),
    notes: (
      <ol>
        <li>
          Estimated date set when the vendor signs the check-in package and
          evaluation proposal is received by NIAP.
        </li>
        <li>
          Actual date set when NIAP releases the evaluation for validator
          resource staffing.
        </li>
      </ol>
    ),
  },
  {
    id: 2,
    owner: "NIAP",
    definition: (
      <>
        <b>Check-In Meeting Completed</b> – Achieved when all parties officially
        commit to the evaluation.
      </>
    ),
    notes: (
      <>
        <ul>
          <li>
            Estimated date set when the Senior validator recommends the project
            for Kickoff.
          </li>
          <li>
            Actual date set when NIAP conducts the Check-in meeting (Formal or
            Electronically) and assigns a Kickoff date.
          </li>
        </ul>
        <p>
          Electronic Check-In should occur within three (3) business days of
          receipt of recommendation approval. Lab must have a current PP6 est.
          date in the evaluation record before NIAP can proceed with kickoff.
        </p>
      </>
    ),
  },
  {
    id: 3,
    owner: "Lab",
    definition: (
      <>
        <b>ST Evaluation Completed</b> – Achieved when the Lab completes its
        evaluation of the Security Target (ST).
      </>
    ),
    notes: null,
  },
  {
    id: 4,
    owner: "Lab",
    definition: (
      <>
        <b>Test Ready</b> – Achieved when the Lab completes the evaluation of
        the Guidance Documents and completes the development of the Test Plan.
      </>
    ),
    notes: null,
  },
  {
    id: 5,
    owner: "Lab",
    definition: (
      <>
        <b>Testing Completed</b> – Achieved when the Lab completes the planned
        testing and is prepared to document their findings.
      </>
    ),
    notes: null,
  },
  {
    id: 6,
    owner: "Lab",
    definition: (
      <>
        <b>Evaluator Checkout Completed</b> – Achieved when the Lab:
        <ul>
          <li>
            Resolves all cited product evaluation and documentation
            deficiencies.
          </li>
          <li>Completes the Evaluation Technical Report (ETR).</li>
          <li>
            Submits the Check-out Package and Product Compliant List (PCL) entry
            information to the Validator for review.
          </li>
        </ul>
      </>
    ),
    notes: null,
  },
  {
    id: 7,
    owner: "Validator",
    definition: (
      <>
        <b>Validator Checkout Completed</b> – Achieved when the Validators
        complete the final draft Validation Report (VR) and submit it to the
        vendor and Lab for release approval.
      </>
    ),
    notes: null,
  },
  {
    id: 8,
    owner: "NIAP",
    definition: (
      <>
        <b>PCL Posting Date</b> – Achieved when NIAP lists the product on the
        PCL and declares the evaluation complete in the Evaluation Record.
      </>
    ),
    notes: (
      <>
        <ul>
          <li>
            Estimated date set when the Senior validator recommends the project
            for Posting.
          </li>
          <li>Actual date set when the product is Posted to the PCL.</li>
        </ul>
        <p>
          Posting should occur within three (3) business days of receipt of
          recommendation approval. Vendor and Lab must have signed the ROI
          (F8002b) Forms before the Sr. Validator can send NIAP recommendation
          approval.
        </p>
      </>
    ),
  },
];
